import { createContext, ReactNode, useContext } from 'react';
import { ClientEnvironment } from '~/env/types';

const EnvironmentContext = createContext<ClientEnvironment | undefined>(
  undefined,
);

export const EnvironmentProvider = ({
  environment,
  children,
}: {
  environment: ClientEnvironment;
  children: ReactNode;
}) => (
  <EnvironmentContext.Provider value={environment}>
    {children}
  </EnvironmentContext.Provider>
);

export const useEnvironment = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error(
      'useEnvironment must be used within an EnvironmentProvider',
    );
  }
  return context;
};
